// Constants.
import * as PayHistoryConstants from 'constants/PayHistoryConstants';
import * as AuthConstants from 'constants/AuthConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  isFetchingMore: false,
  isFetchedMore: true,
  payHistory: {
    results: [],
  },
  limit: 5,
  offset: 0,
  errorMessage: '',
};

export default function products(state = initialState, action = {}) {
  switch (action.type) {
    case PayHistoryConstants.LOAD_PAY_HISTORY_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFetched: false,
      };
    case PayHistoryConstants.LOAD_PAY_HISTORY_SUCCESS: {
      const offset = state.offset + state.limit;
      return {
        ...state,
        offset,
        isFetching: false,
        isFetched: true,
        payHistory: action.payHistory,
      };
    }
    case PayHistoryConstants.LOAD_PAY_HISTORY_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        payHistory: {
          results: [],
        },
      };
    case PayHistoryConstants.LOAD_PAY_HISTORY_MORE_REQUEST:
      return {
        ...state,
        isFetchingMore: true,
        isFetchedMore: false,
      };
    case PayHistoryConstants.LOAD_PAY_HISTORY_MORE_SUCCESS: {
      const offset = state.offset + state.limit;
      const payHistory = action.payHistory;
      payHistory.results = state.payHistory.results.concat(payHistory.results);
      return {
        ...state,
        offset,
        payHistory,
        isFetchingMore: false,
        isFetchedMore: true,
      };
    }
    case PayHistoryConstants.LOAD_PAY_HISTORY_MORE_FAILURE:
      return {
        ...state,
        isFetchingMore: false,
        isFetchedMore: false,
        payHistory: {
          results: [],
        },
      };
    case AuthConstants.LOGOUT_SUCCESS:
    case AuthConstants.LOGOUT_TOKEN_SUCCESS:
    case ErrorConstants.LOAD_REQUEST_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        isFetchingMore: false,
        isFetchedMore: true,
        payHistory: {
          results: [],
        },
        limit: 5,
        offset: 0,
        errorMessage: '',
      };
    default:
      return state;
  }
}
